import React from 'react';
import { motion } from 'framer-motion';

export const LoadingConversation = () => {
  return (
    <motion.div
      key="loading"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="w-full flex items-center justify-center py-20"
      data-name="loading"
    >
      <div className="flex flex-col items-center gap-4">
        <div className="animate-spin rounded-full size-8 border-2 border-t-transparent border-primary" />
        <p className="text-sm text-secondary-foreground">Loading conversation...</p>
      </div>
    </motion.div>
  );
};
